module.exports = __webpack_public_path__ + "images/marketing_site/SalesAnalytics_HighestUserAdoption_Adoption.svg";